<template>
  <vx-card>
     <vs-tabs>
      <vs-tab :label="$t('document_title_document')">
        <form-document :id="id"></form-document>
      </vs-tab>
      <vs-tab v-if="id" :label="$t('document_destination')">
        <form-document-destination :id="id"></form-document-destination>
      </vs-tab>
    </vs-tabs>
  </vx-card>
</template>

<script>

import standard from '@/services/standard'

import {
  VBTooltip,
} from 'bootstrap-vue'

import DocumentService from '@/services/api/DocumentService'

import FormDocument from './FormDocument.vue'
import FormDocumentDestination from './FormDocumentDestination.vue'

export default {
   directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    FormDocument,
    FormDocumentDestination
  },
  props: {
    id: {
      default: null,
      type: Number
    }
  },
  data: () => ({
    service: null,

  }),
  methods: {

  },
  computed: {

  },
  beforeMount() {
    this.service = DocumentService.build(this.$vs)

  },
}
</script>


<style lang="scss" scoped>
  ::v-deep .vs-popup {
    width: 800px !important;
  }
</style>
